export default __webpack_public_path__ + "static/media/discoverAndShare.0b393198.png";